var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path12, _path13, _path14, _path15, _path16, _path17, _circle3, _path18, _path19, _polygon2, _path20, _path21, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplyFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ef801be8-9fb2-4433-98fc-7ef75631d0fc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 881.38948,
    height: 697.50827,
    viewBox: "0 0 881.38948 697.50827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "277.171 365.785 286.074 393.129 298.156 382.954 291.797 361.334 277.171 365.785",
    fill: "#ffb9b9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.01405,350.66111l3.1795,42.60535,76.944,1.9077,33.70274,76.944,18.44112-7.63081s-20.98473-72.49269-30.52324-95.38512-45.78485-6.359-45.78485-6.359l-3.17951-6.359Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441.56339,489.28748s1.27181,20.34882,3.17951,21.62062,16.53342-1.2718,16.53342-1.2718,4.39448.97636,22.25652-3.8154c20.08112-5.38707-2.5436-13.35392-2.5436-13.35392s-14.62572-9.53851-20.98472-13.98981-10.81032,5.0872-10.81032,5.0872C450.466,487.37978,441.56339,489.28748,441.56339,489.28748Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M950.333,571.68067l2.0243,70.85119L973.95,725.52893s-4.72339,14.17023-1.34955,17.54413,18.89368,9.44684,18.89368,9.44684L978.67354,575.72931Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M997.21285,742.72724s7.70031,16.94067-3.08014,18.48071-60.57569,5.64691-57.49561-3.08014S977.192,741.18714,977.192,741.18714Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.90761,508.92676s-8.09729,43.86023-13.49548,51.28278,2.69909,61.40435,2.69909,61.40435,12.14594,77.59894,6.74774,89.74482-4.04864,8.09729-3.37384,14.845,2.0243,12.14593,0,18.21887-2.02429,5.39819-2.69909,8.772,0,21.59271,0,21.59271-29.01526,10.12159-33.73865-4.72339c0,0,6.74774-9.44683,4.72339-16.86932a89.86533,89.86533,0,0,1-3.37384-22.94226V716.08209l-31.03955-116.061-7.42249-41.83594s2.02429-42.51071,9.44684-46.55932S1025.90761,508.92676,1025.90761,508.92676Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.76174,771.41352s10.12158,22.26751-4.04865,24.2918-79.62323,7.42249-75.57458-4.04864,53.30706-22.26752,53.30706-22.26752Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 841.62872,
    cy: 186.38349,
    r: 26.99091,
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.90053,299.55655l-.50244,34.46924-33.09125.11206s8.39826-26.98331,4.63654-32.62573S1019.90053,299.55655,1019.90053,299.55655Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M970.57625,353.0542s23.61707-30.36478,41.83594-17.5441,24.96661,43.18546,24.96661,43.18546l-4.04864,85.02142s-10.12159,12.14594-4.04865,20.2432,9.44684,6.073,4.72345,12.1459-10.12158,10.79636-8.09729,12.82068-2.02429,3.37387-2.02429,3.37387l-71.526,2.02432s2.02429-2.69909-4.04865-10.79635,1.34955-18.89365,0-22.94229-2.69909.67477-3.37384-8.77207S970.57625,353.0542,970.57625,353.0542Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M977.324,527.14563s-1.34955,16.86933-11.47113,19.56842c-3.79559,1.01215-6.64227-.9173-8.718-3.72442a16.57147,16.57147,0,0,1-.52978-18.59165l2.5-4.00009Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#ffb9b9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.7405,318.97812s.67474,13.49548,0,15.51978-1.34955,4.04864,0,6.07293.67474,8.772-.67481,9.44684,2.6991,6.74774,1.34955,10.79636-2.6991,5.39819-3.37384,6.74774-1.76178,3.76746-1.76178,3.76746-19.831-42.22953-36.02551-32.108-29.01526,13.49546-29.01526,13.49546S979.01088,305.48267,1039.7405,318.97812Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#3f3d56"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.38783,350.35507s21.59272,2.02433,20.24317,30.36478,2.02429,72.87549,2.02429,72.87549-37.11255,56.68094-43.18549,60.72955-6.74774,3.37387-6.073,6.74774,1.34954,6.073-1.34955,8.772a23.29927,23.29927,0,0,1-5.3982,4.04864s-21.59271-7.42248-19.56842-14.17023,11.47113-17.54409,11.47113-17.54409,16.19458-26.31617,16.86933-30.36478.6748-3.37387,2.6991-5.39819,7.42248-10.12159,7.42248-14.17023V439.42514l-5.6571-68.514a19.86233,19.86233,0,0,1,5.26757-15.38235C998.36464,352.169,1003.2184,349.49475,1010.38783,350.35507Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M983.52748,266.81447a10.998,10.998,0,0,1-10.19134-2.3335c-2.63764-2.50631-3.52417-6.8488-1.6474-9.96592,1.62066-2.69173,4.77264-4.00817,7.772-4.944a68.8087,68.8087,0,0,1,20.43591-3.1171c3.3039-.001,6.75379.28063,9.58106,1.99013,1.39892.84585,2.58368,2.00755,3.96673,2.87907,2.54309,1.60253,5.59687,2.13506,8.389,3.24832a21.51954,21.51954,0,0,1,12.26422,12.98767,25.93067,25.93067,0,0,1,1.1919,6.10035,33.42482,33.42482,0,0,1-2.91626,16.568c-3.76508,8.20969-10.93116,15.11261-11.94367,24.08759-3.85748-3.23826-4.98822-8.67008-7.97613-12.72464a16.49817,16.49817,0,0,0-9.00678-6.11335,5.24446,5.24446,0,0,1-2.72748-1.21917,4.51834,4.51834,0,0,1-.85351-2.45786l-1.85193-13.33426c-.37689-2.71371-.886-5.67932-2.96844-7.45968a10.55473,10.55473,0,0,0-4.42176-1.9188,71.31622,71.31622,0,0,0-11.54242-1.88212",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1029.37355,463.23432l-37.87933,49.15676S1026.37355,483.23432,1029.37355,463.23432Z",
    transform: "translate(-159.30526 -101.24586)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "833.709 307.563 834.068 353.988 812.068 386.988 830.068 349.988 833.709 307.563",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M762.31233,386.77882H532.88008V382.05H428.84659v4.72878h-230.378a15.51936,15.51936,0,0,0-15.51937,15.51933V716.46147a15.51939,15.51939,0,0,0,15.51937,15.51936H762.31233a15.51936,15.51936,0,0,0,15.51936-15.51941V402.29818a15.51934,15.51934,0,0,0-15.51936-15.51936Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.45069,
    y: 312.95998,
    width: 553.26907,
    height: 312.10048,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.61233,
    cy: 298.77359,
    r: 5.67456,
    fill: "#fade32"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.37956,
    y: 312.80417,
    width: 549.77508,
    height: 311.98472,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.10026,
    y: 334.12224,
    width: 518.33369,
    height: 271.00468,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.19798,
    y: 362.24119,
    width: 133.18734,
    height: 214.7668,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 264.37599,
    y: 362.24119,
    width: 110.98945,
    height: 59.11699,
    fill: "#fade32"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 264.37599,
    y: 437.82114,
    width: 110.98945,
    height: 63.60689,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 264.37599,
    y: 517.89099,
    width: 110.98945,
    height: 59.11699,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 399.14889,
    y: 362.24119,
    width: 133.18734,
    height: 93.59419,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 399.14889,
    y: 483.41379,
    width: 133.18734,
    height: 93.59419,
    fill: "#fade32"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M793.36628,720.63178H739.37082v-3.89037a.77134.77134,0,0,0-.77135-.77135H720.08673a.77135.77135,0,0,0-.77136.77135h0v3.89037H707.74494v-3.89037a.77135.77135,0,0,0-.77136-.77135H688.46084a.77135.77135,0,0,0-.77136.77135h0v3.89037H676.119v-3.89037a.77134.77134,0,0,0-.77135-.77135H656.8349a.77135.77135,0,0,0-.77136.77135h0v3.89037H644.4931v-3.89037a.77134.77134,0,0,0-.77135-.77135H625.209a.77135.77135,0,0,0-.77136.77135h0v3.89037H612.86716v-3.89037a.77134.77134,0,0,0-.77135-.77135H593.58306a.77134.77134,0,0,0-.77135.77135h0v3.89037H581.24127v-3.89037a.77134.77134,0,0,0-.77135-.77135H561.95718a.77135.77135,0,0,0-.77136.77135h0v3.89037H549.61533v-3.89037a.77135.77135,0,0,0-.77136-.77135H403.82757a.77136.77136,0,0,0-.77136.77135h0v3.89037H391.48575v-3.89037a.77134.77134,0,0,0-.77133-.77135H372.20165a.77135.77135,0,0,0-.77135.7713v3.89042H359.85984v-3.89037a.77134.77134,0,0,0-.77133-.77135H340.57577a.77136.77136,0,0,0-.77136.77135h0v3.89037H328.23392v-3.89037a.77134.77134,0,0,0-.77133-.77135H308.94982a.77136.77136,0,0,0-.77135.77135h0v3.89037H296.608v-3.89037a.77133.77133,0,0,0-.77132-.77135H277.32393a.77136.77136,0,0,0-.77135.77135h0v3.89037H264.98212v-3.89037a.77134.77134,0,0,0-.77133-.77135H245.698a.77136.77136,0,0,0-.77135.77135h0v3.89037H233.35617v-3.89037a.77133.77133,0,0,0-.77133-.77135H214.07208a.77136.77136,0,0,0-.77136.77135h0v3.89037H177.818a18.51274,18.51274,0,0,0-18.51273,18.51274v8.371A18.51273,18.51273,0,0,0,177.818,766.02822H793.36628A18.51275,18.51275,0,0,0,811.879,747.51553v-8.371A18.51276,18.51276,0,0,0,793.36628,720.63178Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M297.64822,179.79964a30.08074,30.08074,0,0,0-5.88883,15.46266c-.68624,6.82062-2.68325,17.72983-8.49446,23.464-8.85379,8.73637-11.805,15.28866-11.805,15.28866l2.95125,3.27613c0-6.55231,3.935-7.64434,3.935-7.64434l-.98374,7.64434c26.56132,25.11706,85.58645,2.18406,85.58645,2.18406l-1.96752-19.65684c4.9188,2.1841,6.88628,17.47276,6.88628,17.47276l7.87-2.18406s-13.77251-24.025-22.6263-45.866-22.62629-16.38071-22.62629-16.38071C314.25314,164.18461,303.53209,172.23,297.64822,179.79964Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M390.05543,191.05l9.53851-62.31828s-10.17441-24.80013,6.99491-27.34373,5.72311,29.88734,5.72311,29.88734L406.58885,191.05Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#ffb9b9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.42462,484.20027c3.17951,5.08721,3.81541,31.15914,3.81541,31.15914l22.25652-13.98982-6.359-22.89242Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#ffb9b9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M351.26545,347.48165s-27.97964,0-43.24126,8.90261c-4.90548,2.86155-6.329,8.02254-6.002,13.70916.85411,14.85572,12.98718,26.58794,27.83906,27.50663l43.02491,2.66132c-6.359,17.80522,8.26671,87.11841,8.26671,87.11841l22.89243-3.17951s-3.17951-23.52833-2.5436-24.80013,6.359-50.87206,2.5436-76.944S348.086,367.19453,348.086,367.19453Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M384.96823,509.6363s-1.90771,18.44112-1.27181,20.98473,26.70784,3.8154,50.23616-3.17951-3.1795-14.62571-3.1795-14.62571-15.89752-10.81032-20.34882-14.62572-10.81032,5.08721-10.81032,5.08721C398.32214,509.0004,384.96823,509.6363,384.96823,509.6363Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 323.28585,
    cy: 212.67066,
    r: 22.89244,
    transform: "matrix(0.16018, -0.98709, 0.98709, 0.16018, -97.72859, 396.47015)",
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M313.74734,229.84c8.26671,12.08212-1.9077,19.077-1.9077,19.077l-4.45131,33.06684s47.69256,4.4513,55.95927-1.90771-9.53851-27.34373-15.89752-29.25143-7.63081-27.97963-7.63081-27.97963Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#ffb9b9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M314.9917,245.52912l-25.09064-3.925-2.86155,27.02578s1.2718,60.41057,0,71.22089,21.62062,22.89243,21.62062,22.89243,33.06684-2.54361,39.42585-5.72311,26.70783,3.1795,26.70783,3.1795a17.19543,17.19543,0,0,0,6.677-.95385c3.81541-1.2718-9.85646-91.88764-9.85646-91.88764L359.53219,239.3785l-14.62571,5.7231-4.45131,20.98473Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#fade32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "209.766 165.476 235.202 133.045 253.007 89.168 228.207 79.63 218.032 115.876 200.227 137.497 199.591 141.312 209.766 165.476",
    fill: "#fade32"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M288.92,316.0893l62.99943,2.37128s23.47842-12.93558,27.96295,3.83178-29.03995,9.0933-29.03995,9.0933L290.805,332.5149Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#ffb9b9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M294.35237,311.55321l29.25143,1.90771,3.81541,19.71292s-35.61045-.63588-49.60026-1.27178,0-59.77467,1.9077-77.5799,11.44621-12.718,11.44621-12.718l5.72311,4.4513Z",
    transform: "translate(-159.30526 -101.24586)",
    fill: "#fade32"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "140.135 203.948 165.571 214.123 137.591 208.399 135.683 172.153 140.135 203.948",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "188.155 103.804 146.155 104.804 141.155 83.804 188.155 83.804 188.155 103.804",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyFirst);
export default __webpack_public_path__ + "static/media/apply-first.eb580097aece3c6dab6a898926da938f.svg";
export { ForwardRef as ReactComponent };